import { decode } from "@msgpack/msgpack";

export class WSController {
  constructor() {
    this.clients = [];
  }

  sendJsonMessage(data) {
    this.socket && this.socket.readyState === 1 && this.socket.send(JSON.stringify(data));
  }

  sendBinaryMessage(data) {
    this.socket && this.socket.readyState === 1 && this.socket.send(data, { binary: true });
  }

  mount(address) {
    this.socket = new WebSocket(address);
    this.socket.onclose = function () {
      this.messageHandler = undefined;
      this.clients = [];
    }.bind(this);
    this.socket.binaryType = "arraybuffer";
    this.socket.addEventListener("open", this.wsOpen);
    this.socket.addEventListener("message", this.wsMessage.bind(this));
  }

  unmount() {
    this.messageHandler = undefined;
    this.clients = [];
    if (this.socket !== undefined) {
      this.socket.removeEventListener("open", this.wsOpen);
      this.socket.removeEventListener("message", this.wsMessage.bind(this));
      this.socket.close();
    }
  }

  wsOpen() {
    //this.socket.binaryType = "arraybuffer";
  }

  wsMessage(event) {
    const message = decode(new Uint8Array(event.data));
    //console.log("wsMessage: " + JSON.stringify(message, null, ' '));
    if (this.clients.length > 0) {
      this.clients.forEach(client => client.callback(message));
    } else if (this.messageHandler !== undefined && this.messageHandler != null) {
      this.messageHandler(message);
    }
  }

  addClient(id, callback) {
    this.clients.push({
      id: id,
      callback: callback
    });
  }

  removeClient(id) {
    let foundIndex = -1;
    for (let clientIndex = 0; clientIndex < this.clients.length; clientIndex++) {
      if (this.clients[clientIndex].id == id) {
        foundIndex = clientIndex;
        break;
      }
    }
    if (foundIndex >= 0) {
      this.clients.splice(foundIndex, 1);
    }
  }

  clearClients() {
    this.clients = [];
  }
}
